import CryptoJS from 'crypto-js'
import VueElementLoading from 'vue-element-loading'
import PageTracker from '../../../common/PageTrackerHelper.js'

import { onePageVarifyAwbAndFlyer} from "../../../../services/modules/printlabelservices.js";

export default {
    name: 'Verify AWB and Flyer',
    components: {
        VueElementLoading,
        CryptoJS,
    },
    mixins: [PageTracker],
    data() {
        return {
            hubid: null,
            shipmentBarcode: '',
            flyerBarcode: '',

            /* User details Params */
            outsourcingid: '',
            userrole: '',
            localusermailid: '',
            hubid: '',
            userid: '',
            localuserEmail: '',
            userDataKey:''
        }
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        // let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userrole = userdetail.userrole[0].rolename;
        this.userid = userdetail.userid
        this.localusermailid = userdetail.username;
        this.hubid = userdetail.hubdetails[0]
        this.outsourcingid = userdetail.outsourcingid
        this.localuserEmail = userdetail.email;

    },
    methods: {

        /* Inscan Shipment */
        submitForm(scope) {
            
            this.$validator.validateAll(scope).then(res => {
                if (res) {
                    let inscan_payload = {
                        "shippingId": this.shipmentBarcode.toString(),
                        "flyerBarcode": this.flyerBarcode,
                    }

                    onePageVarifyAwbAndFlyer(inscan_payload, (result) => {
                        console.log("---result-"+JSON.stringify(result));
                        
                        try {
                            if (result.data.code == 200) {
                                this.$alertify.success(result.data.message)
                            } else {
                                this.$alertify.error(result.data.message)
                            }
                        } catch (error) {
                            console.log("----" + error.message);
                        }
                    })
                }
            }).catch(() => {
                console.log('errors exist', this.errors)
              });
        },
        reset(){
            this.shipmentBarcode = "";
            this.flyerBarcode = "";
        }
    }
}




// WEBPACK FOOTER //
// ./src/views/components/RVPVerifyAwbAndFlyer/RVPVerifyAwbAndFlyer.component.js